export default function NotificationPopoverTriggerLabel({ children }) {
  return (
    <div
      className="
      absolute inline-flex items-center justify-center min-w-4 w-auto h-4 px-1 text-xs font-medium text-white bg-orange-500 border-2 whitespace-nowrap
      border-white rounded-full -top-1 -right-2.5
    "
    >
      {children}
    </div>
  );
}
